var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form',{attrs:{"id":"payment-form"}},[_c('div',{ref:"paymentElement",attrs:{"id":"payment-element"}}),_c('div',{attrs:{"id":"error-message"}}),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"text"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }